/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const MetricsDatapointFieldSourceType = {
    Dataset: "Dataset",
};
export const MetricsDatapointFieldType = {
    Integer: "Integer",
    Float: "Float",
    Boolean: "Boolean",
    String: "String",
    Class: "Class",
    Datetime: "Datetime",
    UUID: "UUID",
    SampleIDs: "Sample IDs",
};
export const MetricsMetricWidget = {
    Scalar: "Scalar",
    Line: "Line",
    ConfusionMatrix: "Confusion Matrix",
    Bar: "Bar",
    Histogram: "Histogram",
    ROC: "ROC",
    ScoreGraph: "Score Graph",
    Percentage: "Percentage",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
            body = qs.stringify(body);
        }
        if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title RVAI Metrics Service
 * @version 0.1.0
 */
export class Api extends HttpClient {
    livez = {
        /**
         * @description Get application heartbeat.
         *
         * @tags monitor
         * @name GetHeartbeat
         * @summary Get Heartbeat
         * @request GET:/livez
         * @secure
         */
        getHeartbeat: (params = {}) => this.request({
            path: `/livez`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    metrics = {
        /**
         * @description List all registered metric types. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metrics
         * @name ListMetricTypes
         * @summary List Metric Types
         * @request GET:/metrics
         * @secure
         */
        listMetricTypes: (query, params = {}) => this.request({
            path: `/metrics`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create new metric type. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags metrics
         * @name CreateMetricType
         * @summary Create Metric Type
         * @request POST:/metrics
         * @secure
         */
        createMetricType: (data, params = {}) => this.request({
            path: `/metrics`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List all metric type fields. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metrics
         * @name ListMetricTypeFields
         * @summary List Metric Type Fields
         * @request GET:/metrics/fields
         * @secure
         */
        listMetricTypeFields: (params = {}) => this.request({
            path: `/metrics/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete metric runs. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metric runs
         * @name DeleteMetricRuns
         * @summary Delete Metric Runs
         * @request DELETE:/metrics/runs
         * @secure
         */
        deleteMetricRuns: (query, params = {}) => this.request({
            path: `/metrics/runs`,
            method: "DELETE",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description List metric runs. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metric runs
         * @name ListMetricRuns
         * @summary List Metric Runs
         * @request GET:/metrics/runs
         * @secure
         */
        listMetricRuns: (query, params = {}) => this.request({
            path: `/metrics/runs`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create metric run for a source. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metric runs
         * @name CreateMetricRun
         * @summary Create Metric Run
         * @request POST:/metrics/runs
         * @secure
         */
        createMetricRun: (data, params = {}) => this.request({
            path: `/metrics/runs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List all metric run fields. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metric runs
         * @name ListMetricRunsFields
         * @summary List Metric Runs Fields
         * @request GET:/metrics/runs/fields
         * @secure
         */
        listMetricRunsFields: (params = {}) => this.request({
            path: `/metrics/runs/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get SSE updates for new/updated metric runs for source. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metric runs
         * @name GetMetricRunsUpdates
         * @summary Get Metric Runs Updates
         * @request GET:/metrics/runs/updates
         * @secure
         */
        getMetricRunsUpdates: (query, params = {}) => this.request({
            path: `/metrics/runs/updates`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description Delete metric run. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metric runs
         * @name DeleteMetricRun
         * @summary Delete Metric Run
         * @request DELETE:/metrics/runs/{run_id}
         * @secure
         */
        deleteMetricRun: (runId, params = {}) => this.request({
            path: `/metrics/runs/${runId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get metric run. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metric runs
         * @name GetMetricRun
         * @summary Get Metric Run
         * @request GET:/metrics/runs/{run_id}
         * @secure
         */
        getMetricRun: (runId, params = {}) => this.request({
            path: `/metrics/runs/${runId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Add datapoints to metric run. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metric runs
         * @name AddMetricRunDatapoints
         * @summary Add Metric Run Datapoints
         * @request POST:/metrics/runs/{run_id}
         * @secure
         */
        addMetricRunDatapoints: (runId, data, params = {}) => this.request({
            path: `/metrics/runs/${runId}`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description Get datapoints for metric. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metric runs
         * @name GetMetricRunDatapoints
         * @summary Get Metric Run Datapoints
         * @request GET:/metrics/runs/{run_id}/datapoints
         * @secure
         */
        getMetricRunDatapoints: (runId, query, params = {}) => this.request({
            path: `/metrics/runs/${runId}/datapoints`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get datapoint field for metric. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metric runs
         * @name GetMetricRunDatapointField
         * @summary Get Metric Run Datapoint Field
         * @request GET:/metrics/runs/{run_id}/datapoints/{datapoint_id}/{field_id}
         * @secure
         */
        getMetricRunDatapointField: (runId, datapointId, fieldId, query, params = {}) => this.request({
            path: `/metrics/runs/${runId}/datapoints/${datapointId}/${fieldId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a metric type. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags metrics
         * @name DeleteMetricType
         * @summary Delete Metric Type
         * @request DELETE:/metrics/{metric_id}
         * @secure
         */
        deleteMetricType: (metricId, query, params = {}) => this.request({
            path: `/metrics/${metricId}`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get metric type. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags metrics
         * @name GetMetricType
         * @summary Get Metric Type
         * @request GET:/metrics/{metric_id}
         * @secure
         */
        getMetricType: (metricId, params = {}) => this.request({
            path: `/metrics/${metricId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    prometheus = {
        /**
         * No description
         *
         * @tags monitor
         * @name GetPrometheusMetrics
         * @summary Get Prometheus Metrics
         * @request GET:/prometheus
         * @secure
         */
        getPrometheusMetrics: (params = {}) => this.request({
            path: `/prometheus`,
            method: "GET",
            secure: true,
            ...params,
        }),
    };
    version = {
        /**
         * @description Get application version.
         *
         * @tags monitor
         * @name GetVersion
         * @summary Get Version
         * @request GET:/version
         * @secure
         */
        getVersion: (params = {}) => this.request({
            path: `/version`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
}
//# sourceMappingURL=data:application/json;base64,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